import { useRouter } from "next/navigation";
import React from "react";
import { useSelector } from "react-redux";

import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import { CruiseEdit } from "@/config/app-constant";
import useGtmCustomEvent from "@/hooks/gtm/use-gtm-custom-events";
import { useRenewalStateContext } from "@/providers/renewal-state-provider";
import { RootState } from "@/store/root-reducer";

type CruiseCoverProps = {
  cmsData: {
    cruiseCoverTitle: string;
    cruiseCoverEditButtonLabel: string;
  };
};

function CruiseCover({ cmsData }: Readonly<CruiseCoverProps>) {
  const router = useRouter();
  const { attributes } = useSelector((state: RootState) => state.quote);
  const { cruiseCoverTitle, cruiseCoverEditButtonLabel } = cmsData;
  const { updateLastEditAccordion } = useRenewalStateContext();

  const handleGtmEvent = useGtmCustomEvent({
    event: "custom_events",
    eventName: "edit_cta",
    quoteSection: "policy details",
  });

  return (
    <div>
      <p
        className="font-body-font text-2xs font-[400] leading-[24px] text-text-functional-subtle"
        id="cruise_question"
      >
        {cruiseCoverTitle}
      </p>
      <div className="flex justify-between items-start">
        <div>
          <p className="font-body-font text-xs font-[700] leading-[27px] text-interactive-secondary-default">
            {attributes.tripDetails?.goingOnCruise ? "Yes" : "No"}
          </p>
        </div>
        <div className="h-[18px]" id="cruise_edit">
          <LabelButtonWrapper
            label={cruiseCoverEditButtonLabel}
            hierarchy="tertiary"
            className="font-body-font leading-[18px] font-[600] text-xs py-spacing-xxs realtive top-[-2px] !px-spacing-xxs ml-spacing-m"
            onClick={() => {
              updateLastEditAccordion("policy-details");
              handleGtmEvent();
              router.push(`/cruise?${CruiseEdit}=true`);
            }}
          />
        </div>
      </div>
    </div>
  );
}

export default CruiseCover;
